// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__KQ2Y0"};